/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import { MessageData } from 'cio/services/subscription-center';
import { computed } from '@ember/object';

interface MessageListArgs {
  readOnly: boolean;
  allSelected?: boolean;
  allMessagesOnPageIndeterminate: boolean;
  toggleMessageSelection: (message: MessageData, index: number, checked: boolean) => unknown;
  selectAllOrNone: (checked: boolean) => unknown;
  state: string;
  activeMessageList?: MessageData[];
  selectedMessages?: MessageData[];
  subscriptionTopics?: SubscriptionTopicModel[];
  filterEnabled: boolean;
  isLoading: boolean;
}

export default class MessageList extends Component<MessageListArgs> {
  cheerImage = new URL('cio/assets/images/cheer.png', import.meta.url).toString();

  @computed('args.activeMessageList.@each.pendingActions')
  get showMessageAlertColumn() {
    return (this.args.activeMessageList ?? []).some(({ pendingActions }) => pendingActions?.length > 0);
  }

  get showDoneOnPendingTab() {
    let { activeMessageList, state, filterEnabled } = this.args;
    return activeMessageList?.length === 0 && state === 'pending' && !filterEnabled && !this.args.isLoading;
  }
}
